export default {
  photoPrint: 'photo-print',
  canvas: 'canvas',
  mask: 'mask',
  poster: 'poster',
  calendar: 'calendar',
  photoBook: 'photo-book',
};
